var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-multiple-select',{attrs:{"label":"アクセス権限","value":_vm.value,"items":_vm.selectableAclRoleList,"disabled":_vm.disabled,"placeholder":"(権限なし)","frozen":_vm.frozen},on:{"input":function($event){return _vm.input($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }